import React, { useState } from 'react'

import { ReportType } from 'core'

import { Col, Icon, Row } from 'common/components'

import AiAnalyticsReportSection from './common/AiAnalyticsReportSection'
import EmployeesReportSection from './common/EmployeesReportSection'
import EndOfMonthNewReportSection from './common/EndOfMonthNewReportSection'
import EndOfWeekReportSection from './common/EndOfWeekReportSection'
import PlansAndSeatsReportSection from './common/PlansAndSeatsReportSection'
import ReportQueueItem from './common/ReportQueueItem'
import ReportSection from './common/ReportSection'

export const REPORTS_PATH = 'reports'

const reports = [
  { itemId: '1', name: 'End of Month numbers', compo: ReportSection },
  { itemId: '2', name: 'Plan And Seats Report', compo: PlansAndSeatsReportSection },
  { itemId: '3', name: 'End of Week Companies Report', compo: EndOfWeekReportSection },
  { itemId: '4', name: 'End of Month Companies Report', compo: EndOfMonthNewReportSection },
  { itemId: '5', name: 'AI Analytics Reports', compo: AiAnalyticsReportSection },
  {
    itemId: '6 ',
    name: 'End of Week Employees Report',
    compo: () => <EmployeesReportSection name="Weekly Report" reportType={ReportType.Weekly} />,
  },
  {
    itemId: '7 ',
    name: 'End of Month Employees Report',
    compo: () => <EmployeesReportSection name="Monthly Report" reportType={ReportType.Monthly} />,
  },
]

const Reports = () => {
  const [activeItemId, setActiveItemId] = useState<string>('1')
  const selectedReport = reports.find((report) => report.itemId === activeItemId)
  const ActiveReportComponent = selectedReport.compo

  const handleReportClicked = (itemId: string) => {
    setActiveItemId(itemId)
  }

  return (
    <Row>
      <Col span={6}>
        <>
          <div className="expense_queue__header mr-24">
            <h4>
              <Icon type="far fa-file-check color-green-6 mr-8" fontAwesome />
              Reports
            </h4>
          </div>

          <div className={'expense_queue mr-24'}>
            {reports.map((report) => (
              <ReportQueueItem report={report} onClick={handleReportClicked} active={activeItemId === report.itemId} />
            ))}
          </div>
        </>
      </Col>
      <Col span={18} className={'mb-16'}>
        <ActiveReportComponent name={selectedReport.name}></ActiveReportComponent>
      </Col>
    </Row>
  )
}

export default Reports
